import React, { useState } from "react";
import Resume from "./resume";
import Styles from "../../styles.module.scss";
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader";
import { makeSideBarActive } from "../../../../utils/EllowUtils";
import * as CONSTANTS from "../../../../utils/CONSTANTS";
import PersonalDetails from "./personalDetails";
import { useLocation, useNavigate } from "react-router-dom";
import { getDetails, saveReferedCandidateDetails, getkExcistingEmail } from "./services";
import NotificationAlert from "../../../../components/notification";
import mixpanelData from "../../../../utils/mixpanel";

function ReferAndEarnProfile() {

  const navigate = useNavigate()
  const location = useLocation()
  const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 7);
  const job: any = location.state ? location.state : null
  const loginId = localStorage.getItem('loginId')
  const jobId = job.jobRole.jobId;
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [candidateId, setCandidateId] = useState<string>('')
  const [resume, setResume] = useState<string | null>(null)
  const [defaultValues, setDefaultValues] = useState<any>()
  const[error,setError] = useState <string> ('')
  const [disableBtn, setDisableBtn] = useState<boolean>(false)
  const [resumeError, setResumeError] = useState<string>('')
  const email = localStorage.getItem('Email') || ''
  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('/referandearn')
     }, 4000);
  }
  
  const submitCandidateDetails = (data: any) => {

      let payload = {
        "loginId": candidateId && candidateId !== '' ? candidateId : '',
        "userLoginId": loginId,
        "submittedBy": "FREELANCER",
        "sourcedBy": "REFERRAL",
        "behalfOf": loginId,
        "referredJobId": jobId,
        "profileMetadata": {
          "phoneNumber": data.phoneNumber,
          "email": data.email,
          "lastName": data.lastName,
          "firstName": data.firstName,
          "workExperience": data.workExperience,
          "noticePeriod": data.noticePeriod,
          "jobRoles": data.jobRoles
        },
        "candidateStatus": "2"
      }
      if (resume) {
  
        saveReferedCandidateDetails(payload).then((response: any) => {
          if (response && response.status === 1) {
            displayNotification('Candidate refered successfully')
            mixpanelData('New MWP - Refer Candidate',{
              "distinct_id": loginId,
              "Referee email id": email,
              "Candidate Name": data.firstName + ' ' + data.lastName,
              "Email id": data.email,
              "Phone number": data.phoneNumber,
              "Total Experience":  data.workExperience + " Years",
              "Job role": data.jobRoles && data.jobRoles.length > 0 && data.jobRoles.map((item: any) => item.name),
              "Designation": data.positionName,
              "Notice Period": data.noticePeriod + " Months"      
            })
          }
        })
      }
      else {
        setResumeError('Required*')
      }
  }   

  const getUserDetails = (id: string | null) => {
    getDetails(id).then((response) => {
      if (response && response.status === 1) {
        setCandidateId(response.data[0].login_id)
        setResume(response.data[0].resume_file_name)
        let defaultData = {
          email: response.data[0].profile_metadata.email,
          firstName: response.data[0].profile_metadata.firstName,
          lastName: response.data[0].profile_metadata.lastName,
          phoneNumber: response.data[0].profile_metadata.phoneNumber && response.data[0].profile_metadata.phoneNumber.toString() ? response.data[0].profile_metadata.phoneNumber.toString() : '',
          jobRole: response.data[0].profile_metadata.jobRoles,
          positionName: response.data[0].profile_metadata.positionName,
          workExp: response.data[0].profile_metadata.workExperience,
        }
        setDefaultValues(defaultData)
      }
    }
    )
  }

  const checkExcistingEmail = (email: string) => {
    setDisableBtn(false)
    getkExcistingEmail(email).then((response: any) => {
      if (response && response.status === 2){   
        setError('Email id already exist. Try different email') 
        setDisableBtn(true)
      }
      else if(response && response.status === 3){   
        setDisableBtn(false)
        setError('')
      }
    })
  }
  return (
    <section className={Styles.dashboardWrapper}>
      <SideMenu menu={menu} />
      <div className={Styles.dashboardContent}>
        <DashboardHeader />
        {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} >
          {message}
          </NotificationAlert> }
        <div className="contentBox">
          <div className="innerPadd48">
            <Resume loginId={loginId} getUserDetails={getUserDetails} resume={resume} resumeError={resumeError} />
            <PersonalDetails defaultValues={defaultValues} job={job} ClickHandler={submitCandidateDetails} checkExcistingEmail={checkExcistingEmail} error={error} disable={disableBtn}/>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReferAndEarnProfile;
